export enum MapType {
  Streets = 'streets',
  Light = 'light',
  Dark = 'dark',
  Outdoors = 'outdoors',
  Satellite = 'satellite',
  Traffic = 'traffic',
  SatelliteRoyHill = 'satellite_roy_hill',
  StreetsRoyHill = 'streets_roy_hill',
}

export enum VehicleView {
  Driver = 'driver',
  Vehicle = 'vehicle',
  Area = 'area',
  Asset = 'asset',
}

export const TabVehicleView = [VehicleView.Vehicle, VehicleView.Driver, VehicleView.Area, VehicleView.Asset]
